import { useState, useRef, useEffect } from "react";

const CreatableDropdown = ({
  label,
  value,
  options = [],
  onChange,
  placeholder = "Type or select",
}) => {
  const [open, setOpen] = useState(false);
  const [input, setInput] = useState(value || "");
  const wrapperRef = useRef(null);

  useEffect(() => {
    setInput(value || "");
  }, [value]);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filtered = options.filter(opt =>
    opt.toLowerCase().includes(input.toLowerCase())
  );

  const selectValue = (val) => {
    onChange(val);
    setInput(val);
    setOpen(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (input) {
        selectValue(input);
      }
    }
  };

  return (
    <div className="position-relative" ref={wrapperRef}>
      {label && <label className="form-label">{label}</label>}
      <input
        type="text"
        value={input}
        placeholder={placeholder}
        className="form-control"
        onFocus={() => setOpen(true)}
        onChange={(e) => {
          setInput(e.target.value);
          setOpen(true);
        }}
        onKeyDown={handleKeyDown}
      />

      {open && (
        <div
          className="dropdown-menu show w-100 mt-1 p-0"
          style={{
            maxHeight: "180px",
            overflowY: "auto",
            zIndex: 1000,
          }}
        >
          {filtered.length ? (
            filtered.map((opt, i) => (
              <button
                type="button"
                key={i}
                className="dropdown-item"
                onClick={() => selectValue(opt)}
              >
                {opt}
              </button>
            ))
          ) : (
            <div className="dropdown-item text-muted">
              Press Enter to add "{input}"
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CreatableDropdown;
